<div class="content" fxFlex>
  <header fxLayout="column" fxLayoutAlign="space-between left" class="header">
    <h1>{{ 'UserManual.UserManual' | translate }}</h1>
    <div class="custom-mat-form-field">
      <div class="config-label-container">
        <label class="search-label">{{ 'UserManual.SearchManual' | translate }}</label>
      </div>
      <mat-form-field style="width: 500px" appearance="outline" class="config-input">
        <input
          matInput
          type="text"
          required
          autocapitalize="characters"
          autocomplete="off"
          [(ngModel)]="searchTerm"
          [placeholder]="'UserManual.SearchPlaceholder' | translate"
        />
      </mat-form-field>
    </div>
  </header>
  <main class="manual-container">
    <div class="scroll-container">
      <div class="manual-item" *ngFor="let manual of filteredManuals">
        <div class="content-img">
          <img [src]="getSrcImageByType(manual.type)" alt="manual" class="manual-img" />
        </div>

        <div class="manual-info">
          <span class="manual-title">{{ manual.title }}</span>

          <div class="manual-details">
            <span>{{ 'UserManual.Version' | translate }} {{ manual.version }}</span>
            <span>|</span>
            <span>{{ manual.size }}</span>
            <span>|</span>
            <span>{{ manual.date | date : 'dd/MM/yyyy' }}</span>
            <span>|</span>
            <span>
              {{ getTranslatedLanguage(manual.language) }}
            </span>
          </div>

          <div class="manual-actions">
            <button mat-button class="yellow-default-button" type="submit" (click)="downloadManual(manual)">
              <div class="confirm-button">
                <img src="assets/icons/upload.svg" width="20px" class="icon" alt="export" />

                {{ 'UserManual.Download' | translate }}
              </div>
            </button>
            <button
              mat-icon-button
              aria-hidden="false"
              aria-label="Help"
              class="custom-icon"
              (click)="openManual(manual.link)"
              matTooltip="{{ 'UserManual.OpenManual' | translate }}"
              matTooltipPosition="above"
            >
              <img src="assets/icons/export.svg" class="icon" alt="export" />
            </button>
          </div>
        </div>
      </div>
    </div>
  </main>
</div>
